import { render } from "./CustomImageUpload.vue?vue&type=template&id=3196c270"
import script from "./CustomImageUpload.vue?vue&type=script&lang=js"
export * from "./CustomImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__